import {
  wallpaper1,
  wallpaper2,
  wallpaper3,
  wallpaper4,
  wallpaper5,
  wallpaper6,
  wallpaper7,
  wallpaper8,
  wallpaper9,
  wallpaper10,
} from "./index.js";

const wallpaperList = {
  images: [
    { image: wallpaper10 },
    { image: wallpaper1 },
    { image: wallpaper2 },
    { image: wallpaper3 },
    { image: wallpaper4 },
    { image: wallpaper5 },
    { image: wallpaper6 },
    { image: wallpaper7 },
    { image: wallpaper8 },
    { image: wallpaper9 },
  ],
};

export { wallpaperList };
